import { ExplorerCard, SavedViewTypes, SavedWidget } from 'hooks/savedViews/types';
import { transformExplorerCardToDashboard } from 'hooks/savedViews/helpers';
import { LAYOUT_OPTIONS } from 'views/explorer/layoutOptions';

export const SavedStatesActions = {
	SAVE_DASHBOARD: 'SAVE_DASHBOARD',
	SAVE_EXPLORER: 'SAVE_EXPLORER',
	SAVE_WIDGET: 'SAVE_WIDGET',
	DELETE_VIEW: 'DELETE_VIEW',
	NEW_DASHBOARD: 'NEW_DASHBOARD',
	SET_ACTIVE_ITEM: 'SET_ACTIVE_ITEM',
	UPDATE_VIEW: 'UPDATE_VIEW',
	LOAD_VIEWS: 'LOAD_VIEWS',
	SET_ERROR: 'SET_ERROR'
};

export const SavedStatesActionCreator = {
	loadViews: (views) => ({
		type: SavedStatesActions.LOAD_VIEWS,
		payload: views
	}),
	saveExplorer: (id, explorer, name = '') => ({
		type: SavedStatesActions.SAVE_EXPLORER,
		payload: {
			id,
			view: {
				...explorer,
				metaData: {
					type: SavedViewTypes.Explorer,
					name,
					id,
				},
			},
		},
	}),
	newDashboard: (id, name) => ({
		type: SavedStatesActions.NEW_DASHBOARD,
		payload: {
			id,
			view: {
				cards: [],
				layout: {
					layoutStyle: {
						key: LAYOUT_OPTIONS.ONE,
						cardCount: 1
					}
				},
				metaData: {
					type: SavedViewTypes.Dashboard,
					name,
					isFavorite: false,
					id
				}
			}
		},
	}),
	saveWidget: (
		id,
		widget: ExplorerCard,
		selectedDefinitionName,
		filters,
		name = ''
	): { type: string; payload: { id; view: SavedWidget } } => {
		const transformedWidget = transformExplorerCardToDashboard(widget, selectedDefinitionName, filters, name);
		transformedWidget.metaData.id = id;
		return {
			type: SavedStatesActions.SAVE_WIDGET,
			payload: {
				id,
				view: transformedWidget,
			},
		};
	},
	deleteView: (viewType, id) => ({
		type: SavedStatesActions.DELETE_VIEW,
		payload: {
			id,
			viewType,
		},
	}),
	setActiveItem: (id) => ({
		type: SavedStatesActions.SET_ACTIVE_ITEM,
		payload: id,
	}),
	updateView: (view) => {
		const viewType = view?.metaData?.type;

		if (viewType === SavedViewTypes.Widget) {
			return {
				type: SavedStatesActions.UPDATE_VIEW,
				payload: {
					id: view.metaData.id,
					view
				},
			};
		} else if (viewType === SavedViewTypes.Explorer) {
			return {
				type: SavedStatesActions.UPDATE_VIEW,
				payload: {
					id: view.metaData.id,
					view
				},
			};
		} else if (viewType === SavedViewTypes.Dashboard) {
			return {
				type: SavedStatesActions.UPDATE_VIEW,
				payload: {
					id: view.metaData.id,
					view
				},
			};
		} else {
			return {
				type: 'NULL',
				payload: {},
			};
		}
	},
	setError: (error) => {
		return {
			type: SavedStatesActions.SET_ERROR,
			payload: error
		}
	}
};
